import React, { useState } from 'react'
import UserModal from '../components/Modal'

import { FiMenu } from "react-icons/fi"
import { AiOutlineFileText } from "react-icons/ai"

import filter from "../assets/filter.png"
import arrow_right from "../assets/arrow-right.png"

import img_1 from "../assets/img_1.png"
import img_2 from "../assets/img_2.png"
import img_3 from "../assets/img_3.png"
import img_4 from "../assets/img_4.png"

import download from "../assets/download.png"
import check from "../assets/check.png"
import delet from "../assets/delete.png"
import DetailsBtn from '../components/DetailsBtn'

// M e t e r

import svg_meter from "../assets/5 step Dial-01 (1).svg"


import meter from "../assets/Meter/7.png"
import needle from "../assets/Meter/6.png"
import scale1 from "../assets/Meter/1.png"
import scale2 from "../assets/Meter/2.png"
import scale3 from "../assets/Meter/3.png"
import scale4 from "../assets/Meter/4.png"
import scale5 from "../assets/Meter/5.png"

import TooltipComponent from '../components/tooltip'

// import energy_meter from "../assets/energy-meter.png"
// import energy_meter from "../assets/5 step Dial-01.png"
import SimpleAreaChart from '../components/Charts/SimpleAreaChart'
import SimpleBarChart from '../components/Charts/SimpleBarChart'
import MonthBarChart from '../components/Charts/MonthBarChart'
import SimplePieChart from '../components/Charts/SimplePieChart'
import UsageChart from '../components/Charts/UsageChart'
import MyApexChart from '../components/Charts/UsageChart'

import MobSidebar from '../components/MobSidebar'

import { useMediaQuery } from 'react-responsive'
import { ADD_ENERGY, ADMIN_ACTION, AUTOPURCHASE, GET_ALL_SELLERS, GET_ENERGY_LOGS, GET_ENERGY_USER, GET_TOTALENERGY_USER, GET_TX, NEEDLE, PIE_CHART, STOP_ENERGY, twomonthusagePercentage, UPDATE_ENERGY, usagePrediction } from '../helpers/api'
import { useEffect } from 'react'
import { FileURL } from "../helpers/config"

import { useSelector, useDispatch } from "react-redux";

function Dashboard() {
    const authUser = useSelector((state) => state.authReducer)
    console.log("userRRRR", authUser);

    const [active, setActive] = useState(2)
    const [isActive, setIsActive] = useState(2)

    const [dashboard, setDashboard] = useState("analytics")

    const [modalItem, setModalItem] = useState("");
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (modalItemValue) => { setShow(true); setModalItem(modalItemValue) };

    const isMobile = useMediaQuery({ query: '(max-width: 992px)' })
    // const isSmallMobile = useMediaQuery({ query: '(max-width: 767px)' })
    const [data, setData] = useState({
        price: "",
        quantity: "",
        isGreen: ""
    })


    const handleprice = (e) => {
        console.log(e.target.value);
        setData({ ...data, price: e.target.value })
    }
    const handlequantity = (e) => {
        setData({ ...data, quantity: e.target.value })
    }
    const handleisGreen = (e) => {
        setData({ ...data, isGreen: e.target.value })
    }

    const addenergy = async () => {
        try {
            console.log("HHHHHHHHH");
            const payload = {
                price: data.price,
                quantity: data.quantity,
                isGreen: data.isGreen
            }

            console.log(payload);

            const response = await ADD_ENERGY(payload)

            if (response.success) {
                alert("energy added")
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const [req, setReq] = useState([])
    const getallsellers = async () => {
        try {
            const response = await GET_ALL_SELLERS()
            let i;
            for (i = 0; i < response.message.length; i++) {
                console.log(response.message[i]);
            }
            console.log("seLLLLLLL", response.message);

            setReq(response.message)
        }
        catch (e) {
            console.log(e);
        }
    }

    const requestaction = async (requestid, status) => {
        try {

            const payload = {
                requestid: requestid,
                status: status
            }
            const response = await ADMIN_ACTION(payload)
            getallsellers()
        }
        catch (e) {
        }
    }

    const [newtx, setnewTx] = useState([])

    const [tE, setTE] = useState({ amount: "" })


    const totalEnergyUser = async () => {
        try {
            const response = await GET_TOTALENERGY_USER()
            console.log("hiiii", response);
            setTE({ ...tE, amount: response.message })

        }
        catch (e) {
            console.log(e);
        }
    }


    const getTx = async () => {
        try {

            const response = await GET_TX()
            console.log("rrrr", response);
            setnewTx(response.message)
        }
        catch (e) {
            console.log(e);
        }

    }

    const [energy, setEnergy] = useState([])
    const [logs, setLogs] = useState([])


    const get_energy_user = async () => {
        try {
            const response = await GET_ENERGY_USER()
            console.log("rep", response);
            setEnergy(response.message)

            if ((response.message).length > 1) {
                setPriceRange({
                    greenPrice: response.message[0]?.isGreen ? response.message[0]?.price : response.message[1]?.price,
                    notGreenprice: !response.message[0]?.isGreen ? response.message[0]?.price : response.message[1]?.price,
                })

            } else {
                if (response.message[0]?.isGreen) {
                    setPriceRange({ greenPrice: response.message[0]?.price })

                } else {
                    setPriceRange({ notGreenprice: response.message[0]?.price })
                }

            }

        }
        catch (e) {
            console.log(e);
        }

    }

    const [needlepoint, setNeedle] = useState(1)

    const getNeedle = async () => {
        try {
            const response = await NEEDLE()
            console.log(response);
            alert(response.message)
            setNeedle(response.message)
        }
        catch (e) {
            console.log(e);
        }
    }

    const get_energy_logs = async () => {
        try {
            const response = await GET_ENERGY_LOGS()
            console.log("repssss", response);
            setLogs(response.message)
        }
        catch (e) {
            console.log(e);
        }

    }

    const [priceRange, setPriceRange] = useState({ greenPrice: "", notGreenprice: "" })
    const handlepriceRange = (e, status) => {
        console.log(e.target.value);
        console.log("SSSS", status);
        if (status) {
            setPriceRange({ ...priceRange, greenPrice: e.target.value })
        }
        else {
            setPriceRange({ ...priceRange, notGreenprice: e.target.value })

        }
    }

    const updateEnergy = async (id, status) => {
        try {
            console.log("id", id);
            if (status) {
                const payload = {
                    energyid: id,
                    price: priceRange.greenPrice
                }
                const response = await UPDATE_ENERGY(payload)
                if (response.success) {
                    alert("updated")
                }
            }
            else {
                const payload = {
                    energyid: id,
                    price: priceRange.notGreenprice
                }
                const response = await UPDATE_ENERGY(payload)
                if (response.success) {
                    alert("updated")
                }
            }
            get_energy_logs()

            get_energy_user()

        }
        catch (e) {
            console.log(e);
        }
    }

    const stopEnergy = async (id, status) => {
        try {
            const response = await STOP_ENERGY({ energyid: id, status: status })
            if (response.success) {
                alert("Updated")
            }
            get_energy_logs()
            get_energy_user()
        }
        catch (e) {
            console.log(e);
        }
    }


    const autopurchase = async () => {
        try {
            if (needlepoint == 1) {
                const response = await AUTOPURCHASE()
            }
            else {
                console.log("sufficient energy");
            }
        }
        catch (e) {
            console.log(e);
        }
    }


    const [percent, setPercent] = useState({
        key: "",
        data: ""
    })


    const getPercentage = async () => {
        try {
            const response = await twomonthusagePercentage()
            console.log("responseAAAAA", response);
            setPercent({ ...percent, key: response.message.key })
            setPercent({ ...percent, data: response.message.percent })
        }
        catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        get_energy_user()
        getPercentage()

        getallsellers()


        // autopurchase()

        getTx()
        getNeedle()
        get_energy_logs()
        totalEnergyUser()
    }, [])



    return (
        <>
            <section className='dashboard_sec'>
                <div className="container">
                    <div className="row">
                        <div className={`col-lg-3 ${isMobile ? "d-none" : "d-block"}`}>
                            <div className="sidebar">
                                <div className="head_cont d-flex jc-between ai-center">
                                    <div className='d-flex ai-center'>
                                        <FiMenu />
                                        <h5 className='mx-2'>Menu</h5>
                                    </div>
                                </div>
                                <div className="form_cont">
                                    <div className='border_bottom padding'>
                                        <h6 onClick={() => setDashboard("analytics")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "analytics" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "analytics" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "analytics" ? "bold" : "normal"}` }}>Analytics</h6>
                                        <h6 onClick={() => setDashboard("energy")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "energy" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "energy" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "energy" ? "bold" : "normal"}` }}>Energy</h6>
                                        <h6 onClick={() => setDashboard("addEnergy")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "addEnergy" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "addEnergy" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "addEnergy" ? "bold" : "normal"}` }}>Add Energy</h6>
                                        <h6 onClick={() => setDashboard("seller")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "seller" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "seller" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "seller" ? "bold" : "normal"}` }}>Seller</h6>
                                    </div>
                                </div>

                                <div className="head_cont d-flex jc-between ai-center">
                                    <div className='d-flex ai-center'>
                                        <img src={filter} alt="image" className='img-fluid' />
                                        <h5 className='mx-2'>Filters</h5>
                                    </div>
                                </div>

                                <div className="form_cont">
                                    <div className='border_bottom padding'>
                                        <p>Sort By:</p>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefaultPricePaid" />
                                            <label className="form-check-label" htmlFor="flexCheckDefaultPricePaid">
                                                Average price paid
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckCheckedelEctricityConsumed" />
                                            <label className="form-check-label" htmlFor="flexCheckCheckedelEctricityConsumed">
                                                Average electricity consumed
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckCheckedTransactionFees" />
                                            <label className="form-check-label" htmlFor="flexCheckCheckedTransactionFees">
                                                Cost of transaction fees
                                            </label>
                                        </div>
                                    </div>
                                    <div className='border_bottom padding'>
                                        <p>Compare data</p>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault1" />
                                            <label className="form-check-label" htmlFor="flexCheckDefault1">
                                                Lorem Ipsum
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked2" />
                                            <label className="form-check-label" htmlFor="flexCheckChecked2">
                                                Lorem Ipsum
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked3" />
                                            <label className="form-check-label" htmlFor="flexCheckChecked3">
                                                Lorem Ipsum
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked4" />
                                            <label className="form-check-label" htmlFor="flexCheckChecked4">
                                                Lorem Ipsum
                                            </label>
                                        </div>
                                    </div>
                                    <div className='padding'>
                                        <p>Filter By:</p>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefaultData" />
                                            <label className="form-check-label" htmlFor="flexCheckDefaultData">
                                                Data range
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckCheckedPrice" />
                                            <label className="form-check-label" htmlFor="flexCheckCheckedPrice">
                                                Price range
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckCheckedTransaction" />
                                            <label className="form-check-label" htmlFor="flexCheckCheckedTransaction">
                                                Transaction type
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckCheckedEnergy" />
                                            <label className="form-check-label" htmlFor="flexCheckCheckedEnergy">
                                                Energy source
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-9 col-md-12">
                            <div className="right_cont">

                                {
                                    dashboard === "analytics" &&
                                    <div>
                                        <div className='d-flex jc-between ai-center'>
                                            <div>
                                                <div>
                                                    <h3>Wattshare: Your gateway to cheaper, cleaner greener electricity</h3>
                                                    <h4>Personalized electricity consumption insights</h4>
                                                </div>
                                            </div>
                                        </div>


                                        <div className='d-flex jc-between ai-center'>
                                            <div className={`energy_meter mt-5 mx-2 ${isMobile ? "d-block mb-4" : "d-none"}`}>
                                                <img src={meter} alt="image" className='img-fluid meter' />
                                                <img src={needle} alt="image" className='img-fluid needle4' />

                                                <TooltipComponent className="scale1_text" placement="bottom" tooltipText="Abundant Reserve">
                                                    <img src={scale1} alt="image" className='img-fluid scale1' />
                                                </TooltipComponent>

                                                <TooltipComponent className="scale2_text" placement="top" tooltipText="Comfortable Reserve">
                                                    <img src={scale2} alt="image" className='img-fluid scale2' />
                                                </TooltipComponent>

                                                <TooltipComponent className="scale3_text" placement="top" tooltipText="Sufficient Reserve">
                                                    <img src={scale3} alt="image" className='img-fluid scale3' />
                                                </TooltipComponent>

                                                <TooltipComponent className="scale4_text" placement="top" tooltipText="Low Reserve">
                                                    <img src={scale4} alt="image" className='img-fluid scale4' />
                                                </TooltipComponent>

                                                <TooltipComponent className="scale5_text" placement="right" tooltipText="Critical Reserve">
                                                    <img src={scale5} alt="image" className='img-fluid scale5' />
                                                </TooltipComponent>

                                                <p>Low Reserve</p>
                                            </div>
                                            <MobSidebar btnText="Filter">
                                                <div className="sidebar">
                                                    <div className="head_cont d-flex jc-between ai-center">
                                                        <div className='d-flex ai-center'>
                                                            <FiMenu />
                                                            <h5 className='mx-2'>Menu</h5>
                                                        </div>
                                                    </div>
                                                    <div className="form_cont">
                                                        <div className='border_bottom padding'>
                                                            <h6 onClick={() => setDashboard("analytics")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "analytics" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "analytics" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "analytics" ? "bold" : "normal"}` }}>Analytics</h6>
                                                            <h6 onClick={() => setDashboard("energy")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "energy" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "energy" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "energy" ? "bold" : "normal"}` }}>Energy</h6>
                                                            <h6 onClick={() => setDashboard("addEnergy")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "addEnergy" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "addEnergy" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "addEnergy" ? "bold" : "normal"}` }}>Add Energy</h6>
                                                            <h6 onClick={() => setDashboard("seller")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "seller" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "seller" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "seller" ? "bold" : "normal"}` }}>Seller</h6>
                                                        </div>
                                                    </div>
                                                    <div className="form_cont">
                                                        <div className='border_bottom padding'>
                                                            <p>Sort By:</p>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefaultPricePaid" />
                                                                <label className="form-check-label" htmlFor="flexCheckDefaultPricePaid">
                                                                    Average price paid
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckCheckedelEctricityConsumed" />
                                                                <label className="form-check-label" htmlFor="flexCheckCheckedelEctricityConsumed">
                                                                    Average electricity consumed
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckCheckedTransactionFees" />
                                                                <label className="form-check-label" htmlFor="flexCheckCheckedTransactionFees">
                                                                    Cost of transaction fees
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className='border_bottom padding'>
                                                            <p>Compare data</p>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault1" />
                                                                <label className="form-check-label" htmlFor="flexCheckDefault1">
                                                                    Lorem Ipsum
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked2" />
                                                                <label className="form-check-label" htmlFor="flexCheckChecked2">
                                                                    Lorem Ipsum
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked3" />
                                                                <label className="form-check-label" htmlFor="flexCheckChecked3">
                                                                    Lorem Ipsum
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked4" />
                                                                <label className="form-check-label" htmlFor="flexCheckChecked4">
                                                                    Lorem Ipsum
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className='padding'>
                                                            <p>Filter By:</p>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefaultData" />
                                                                <label className="form-check-label" htmlFor="flexCheckDefaultData">
                                                                    Data range
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckCheckedPrice" />
                                                                <label className="form-check-label" htmlFor="flexCheckCheckedPrice">
                                                                    Price range
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckCheckedTransaction" />
                                                                <label className="form-check-label" htmlFor="flexCheckCheckedTransaction">
                                                                    Transaction type
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckCheckedEnergy" />
                                                                <label className="form-check-label" htmlFor="flexCheckCheckedEnergy">
                                                                    Energy source
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </MobSidebar>
                                        </div>


                                        <div className="row">
                                            <div className="col-lg-4 col-md-6 col-12 chart_one">
                                                <div className=' mb-5 mt-5 px-0'>
                                                    <img src={svg_meter} alt="img" className='img-fluid' />
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-12 chart_two">
                                                <div className=' mb-5 mt-5 px-0' >
                                                    <div className="row d-flex jc-center ai-center text-center">
                                                        <div className="col-lg-12 col-md-12 col-12">
                                                            <div className="graph">
                                                                <MonthBarChart />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-12 chart_three">
                                                <div className=' mb-5 mt-5 px-0'>
                                                    <div className="graph">
                                                        <SimplePieChart />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-md-12 col-12 chart_four">
                                                <div className=' mb-5 mt-5 px-0'>
                                                    <div className="graph">
                                                        <MyApexChart />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='graph_card mb-5 mt-5'>
                                            <div>
                                                <h4>Monthly </h4>
                                            </div>
                                            <div className="graph">
                                                <SimpleAreaChart />
                                            </div>
                                        </div>

                                        <div>
                                            <h4>Personalized electricity consumption insights</h4>
                                        </div>
                                        <div className='graph_card'>
                                            <div>
                                                <h4>Monthly Sold Vs Purchase</h4>
                                            </div>
                                            <div className="graph">
                                                <SimpleBarChart />
                                            </div>
                                        </div>

                                        <div className='table-responsive'>
                                            <table className="table table-striped mt-5 text-center">
                                                <thead>
                                                    {/* energy new area */}
                                                    <tr>
                                                        <th scope="col">Energy Type</th>
                                                        <th scope="col">Transaction Status</th>
                                                        <th scope="col">Transaction Type</th>
                                                        <th scope="col">Auto Purchase</th>
                                                        <th scope="col">Price/kwh</th>
                                                        <th scope="col">Quantity</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th scope="row">Green</th>
                                                        <td>Success</td>
                                                        <td>Sold</td>
                                                        <td><img src={check} alt="image" className='img-fluid' /></td>
                                                        <td>
                                                            <span>100 Matic per kwh</span> <br />
                                                            <small>(2.5 USD)</small>
                                                        </td>
                                                        <td>10</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Not Green</th>
                                                        <td>Fail</td>
                                                        <td>Purchase</td>
                                                        <td><img src={delet} alt="image" className='img-fluid' /></td>
                                                        <td>
                                                            <span>100 Matic per kwh</span> <br />
                                                            <small>(2.5 USD)</small>
                                                        </td>
                                                        <td>10</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                }

                                {
                                    dashboard === "energy" &&
                                    <section className='energy_sec'>
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 mt-4">
                                                    <div className="bg-success card h-200 p-4">
                                                        <div className="content">

                                                            <h4 className='mb-0'>Green Energy Available : 10 kwh</h4>
                                                            <h4>Price: $50</h4>

                                                            <div className='d-flex energy_btn'>
                                                                <UserModal btnText="Update Energy" id={`Update Energy`} customClasses="me-3" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                                                    <div>
                                                                        <h3 className='text-center mb-4'>Price per kwh</h3>
                                                                        <div className='d-flex jc-between ai-center'>
                                                                            <div className='mb-4'>
                                                                                <label for="customRange1" className="form-label">Set your price range</label>
                                                                                <input type="range" min="1" className="form-range" id="customRange1"></input>
                                                                            </div>
                                                                            <div className='value'>
                                                                                <p >$50</p>
                                                                            </div>
                                                                        </div>
                                                                        <button className='btn confirm_btn'> Confirm</button>
                                                                    </div>
                                                                </UserModal>

                                                                {/* {/* <button className='btn energy_btn me-3'>Update Energy</button> */}
                                                                <button className='btn me-3'>Stop Energy</button>
                                                                <button className='btn me-3'>Start Energy</button>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 mt-4">
                                                    <div className="bg-purple card h-200 p-4">
                                                        <div className="content">

                                                            <h4 className='mb-0'>Energy Available : 20 kwh</h4>
                                                            <h4>Price: $80</h4>

                                                            <div className='d-flex energy_btn'>
                                                                <UserModal btnText="Update Energy" id="Update Energy" customClasses="me-3" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                                                    <div>
                                                                        <h3 className='text-center mb-4'>Price per kwh</h3>
                                                                        <div className='d-flex jc-between ai-center'>
                                                                            <div className='mb-4'>
                                                                                <label for="customRange1" className="form-label">Set your price range</label>
                                                                                <input type="range" min="1" className="form-range" id="customRange1"></input>
                                                                            </div>
                                                                            <div className='value'>
                                                                                <p >$ 50</p>
                                                                            </div>
                                                                        </div>
                                                                        <button className='btn confirm_btn'> Confirm</button>
                                                                    </div>
                                                                </UserModal>

                                                                {/* {/* <button className='btn energy_btn me-3'>Update Energy</button> */}
                                                                <button className='btn me-3'>Stop Energy</button>
                                                                <button className='btn me-3'>Start Energy</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className='table-responsive'>
                                                <table className="table table-striped mt-5 text-center">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Action</th>
                                                            <th scope="col">Price</th>
                                                            <th scope="col">Energy Id</th>
                                                            <th scope="col">IsGreen</th>
                                                            <th scope="col">Timestamp</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>True</td>
                                                            <td>50</td>
                                                            <td>011112255</td>
                                                            <td>Yes</td>
                                                            <td>135484132498</td>
                                                        </tr>
                                                        <tr>
                                                            <td>False</td>
                                                            <td>80</td>
                                                            <td>02221212</td>
                                                            <td>No</td>
                                                            <td>8786943124687435</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </section>
                                }

                                {
                                    dashboard === "addEnergy" &&
                                    <section className='add_energy_sec'>
                                        <div className="container">

                                            <div className='d-flex justify-content-end'>
                                                <MobSidebar btnText="Filter">
                                                    <div className="sidebar">
                                                        <div className="head_cont d-flex jc-between ai-center">
                                                            <div className='d-flex ai-center'>
                                                                <FiMenu />
                                                                <h5 className='mx-2'>Menu</h5>
                                                            </div>
                                                        </div>
                                                        {/* integrate here  */}
                                                        <div className="form_cont">
                                                            <div className='border_bottom padding'>
                                                                <div>
                                                                    <h6 onClick={() => setDashboard("analytics")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "analytics" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "analytics" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "analytics" ? "bold" : "normal"}` }}>Analytics</h6>
                                                                </div>
                                                                <div>
                                                                    <h6 onClick={() => setDashboard("energy")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "energy" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "energy" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "energy" ? "bold" : "normal"}` }}>Energy</h6>
                                                                </div>
                                                                <div>
                                                                    <h6 onClick={() => setDashboard("addEnergy")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "addEnergy" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "addEnergy" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "addEnergy" ? "bold" : "normal"}` }}>Add Energy</h6>

                                                                </div>
                                                                <div>
                                                                    <h6 onClick={() => setDashboard("seller")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "seller" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "seller" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "seller" ? "bold" : "normal"}` }}>Seller</h6>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="form_cont">
                                                            <div className='border_bottom padding'>
                                                                <p>Sort By:</p>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                                                        Average price paid
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                        Average electricity consumed
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                        Cost of transaction fees
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className='border_bottom padding'>
                                                                <p>Compare data</p>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                                                        Lorem Ipsum
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                        Lorem Ipsum
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                        Lorem Ipsum
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                        Lorem Ipsum
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className='padding'>
                                                                <p>Filter By:</p>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                                                        Data range
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                        Price range
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                        Transaction type
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                        Energy source
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </MobSidebar>
                                            </div>

                                            <div className="card jc-center mt-2">
                                                <h3>Add Energy</h3>
                                                <div className="mb-3">
                                                    <label className="form-label mb-2">Price</label>
                                                    <input type="number" className="form-control" placeholder='Enter here' />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label mb-2">Energy (kwh)</label>
                                                    <input type="number" className="form-control" placeholder='Enter here' />
                                                </div>
                                                <div className='mb-5'>
                                                    <label className="form-check-label mb-2">Is Green?</label>
                                                    <select className="form-select form-control" aria-label="Default select example">
                                                        <option selected disabled >Select</option>
                                                        <option value="true">Yes</option>
                                                        <option value="false">No</option>
                                                    </select>
                                                </div>
                                                <button className="btn submit_btn">Submit</button>

                                            </div>
                                        </div>
                                    </section>
                                }

                                {
                                    dashboard === "seller" &&
                                    <section className='seller_sec'>
                                        <div className="container">
                                            <div className='d-flex jc-between ai-center'>
                                                <div>
                                                    <h3 className='mb-0'>Seller</h3>
                                                </div>
                                                <div className='d-flex justify-content-end'>
                                                    <MobSidebar btnText="Filter">
                                                        <div className="sidebar">
                                                            <div className="head_cont d-flex jc-between ai-center">
                                                                <div className='d-flex ai-center'>
                                                                    <FiMenu />
                                                                    <h5 className='mx-2'>Menu</h5>
                                                                </div>
                                                            </div>
                                                            <div className="form_cont">
                                                                <div className='border_bottom padding'>
                                                                    <h6 onClick={() => setDashboard("analytics")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "analytics" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "analytics" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "analytics" ? "bold" : "normal"}` }}>Analytics</h6>
                                                                    <h6 onClick={() => setDashboard("energy")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "energy" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "energy" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "energy" ? "bold" : "normal"}` }}>Energy</h6>
                                                                    <h6 onClick={() => setDashboard("addEnergy")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "addEnergy" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "addEnergy" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "addEnergy" ? "bold" : "normal"}` }}>Add Energy</h6>
                                                                    <h6 onClick={() => setDashboard("seller")} style={{ cursor: "pointer", marginBottom: "0.8rem", color: `${dashboard == "seller" ? "#8f43ed" : "#8F8D8D"}`, fontSize: `${dashboard == "seller" ? "1rem" : "14px"}`, fontWeight: `${dashboard == "seller" ? "bold" : "normal"}` }}>Seller</h6>
                                                                </div>
                                                            </div>
                                                            <div className="form_cont">
                                                                <div className='border_bottom padding'>
                                                                    <p>Sort By:</p>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                                                            Average price paid
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                        <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                            Average electricity consumed
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                        <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                            Cost of transaction fees
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className='border_bottom padding'>
                                                                    <p>Compare data</p>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                                                            Lorem Ipsum
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                        <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                            Lorem Ipsum
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                        <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                            Lorem Ipsum
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                        <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                            Lorem Ipsum
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className='padding'>
                                                                    <p>Filter By:</p>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                                                            Data range
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                        <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                            Price range
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                        <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                            Transaction type
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                                                        <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                            Energy source
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </MobSidebar>
                                                </div>
                                            </div>

                                            <div className='table-responsive'>
                                                <table className="table table-striped mt-5 text-center">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" style={{ textAlign: "left" }}>Name</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Email</th>
                                                            <th scope="col">Certification</th>
                                                            <th scope="col">Approve/Reject</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">
                                                                <div className='d-flex ai-center image'>
                                                                    <img src={img_1} alt="image" className='img-fluid me-2' />
                                                                    User 1
                                                                </div>
                                                            </th>
                                                            <td>
                                                                <small className='success'>
                                                                    Approved
                                                                </small>
                                                            </td>
                                                            <td>user1@gmail.com</td>
                                                            <td>
                                                                <a href="#">
                                                                    <AiOutlineFileText style={{ fontSize: "24px", color: "#8f43ed", cursor: "pointer" }} />
                                                                </a>
                                                            </td>

                                                            <td>
                                                                <button className='btn'>
                                                                    <img src={delet} alt="image" className='img-fluid' />
                                                                </button>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th scope="row">
                                                                <div className='d-flex ai-center image'>
                                                                    <img src={img_1} alt="image" className='img-fluid me-2' />
                                                                    User 2
                                                                </div>
                                                            </th>
                                                            <td>
                                                                <small className='failed'>
                                                                    Rejected
                                                                </small>
                                                            </td>
                                                            <td>
                                                                user2@gmail.com
                                                            </td>
                                                            <td>
                                                                <a href="#">
                                                                    <AiOutlineFileText style={{ fontSize: "24px", color: "#8f43ed", cursor: "pointer" }} />
                                                                </a>
                                                            </td>

                                                            <td>
                                                                <button className='btn'>
                                                                    <img src={check} alt="image" className='img-fluid' />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </section>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Dashboard
